import { scopesForRole } from '@mesa/core/auth/types';
import { createMiddleware } from '@tanstack/react-start';
import { getVcs } from '../token-provider';
import { baseAuthMiddleware } from './base-auth';

export const vcsAuthMiddleware = createMiddleware({ type: 'function' })
  .middleware([baseAuthMiddleware])
  .server(async ({ next, context }) => {
    const vcs = getVcs().withAuth({
      orgId: context.org.id,
      scopes: scopesForRole(context.member.role),
      repoIds: null,
      sub: context.session.user.id,
      actor: context.impersonatedBy ?? context.session.user.id,
      user: {
        id: context.session.user.id,
        name: context.session.user.name,
        email: context.session.user.email,
      },
      authors: null,
      credentialType: null,
    });

    return next({
      context: { vcs },
    });
  });
